export default "__VITE_ASSET__CeF8IzkH__"